import { PropsWithChildren, useEffect, ElementType, FC, memo } from 'react';
import classNames from 'classnames';

import ContactWithManagerButton from 'application/components/ContactWithManagerButton';
import LogoutSmallButton from 'application/components/LogoutSmallButton';
import { useAuthContext } from 'application/providers/AuthProvider';
import Logo from 'application/components/Logo';
import { useAppSelector } from 'application/providers/StoreProvider';
import { selectShowContactWithManagerButton } from 'application/store';
import WebPlayerWidget from 'application/components/widgets/WebPlayer';
import { useWebPlayerContext } from 'application/providers/WebPlayerProvider';

import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import styles from './index.module.scss';

const DEFAULT_TITLE = 'Звук Бизнес';

export type CleanMainProps = PropsWithChildren<{
  containerClassName?: string;
  contentClassName?: string;
  title?: string;
  contentContainerAs?: ElementType;
}>;

const CleanMain: FC<CleanMainProps> = (props) => {
  const { children, title, contentContainerAs: Renderer = 'div', contentClassName, containerClassName } = props;
  const authContext = useAuthContext();

  const { isDesktop, isMobile } = useMedia();
  const showContactWithManagerButton = useAppSelector(selectShowContactWithManagerButton);

  const { isWidgetActive } = useWebPlayerContext();

  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
  }, [title]);

  return (
    <main className={styles.CleanMain}>
      <header className={classNames(styles.CleanMainHeader)}>
        {isMobile && showContactWithManagerButton && (
          <ContactWithManagerButton className={styles.CleanMainContactButton} />
        )}

        <Logo />

        {isMobile && !!authContext.authToken && <LogoutSmallButton className={styles.CleanMainLogoutButton} />}
      </header>

      <section className={classNames(styles.CleanMainSection, containerClassName)}>
        <Renderer className={classNames(styles.CleanMainSectionContent, contentClassName)}>{children}</Renderer>
      </section>

      {isDesktop && showContactWithManagerButton && (
        <ContactWithManagerButton className={styles.CleanMainContactButton} />
      )}

      {isDesktop && !!authContext.authToken && <LogoutSmallButton className={styles.CleanMainLogoutButton} />}

      {isWidgetActive && <WebPlayerWidget />}
    </main>
  );
};

export default memo(CleanMain);
